module.exports={
  "Dodge (tool)": "Dodge",
  "Burn (tool)": "Burn",
  "Color (picker)": "Color",
  
  "Color swatches (shorter)": "Swatches"
}